import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { ArrowLeftCircle, ArrowRightCircle, ChevronDoubleUp, ChevronDoubleDown} from 'react-bootstrap-icons';
import {Image} from "react-bootstrap";
import ImageNotFound from '../../assets/img/image_not_found.webp';
import { useEffect } from 'react';


const ImageGallery = ({productItem}) => {
    // Создаем состояние для хранения выбранного изображения
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [selectedImage, setSelectedImage] = useState('');
    const [startIndex, setStartIndex] = useState(0);
    const [imagesToShow, setImagesToShow] = useState(4);

    // сколько выводим маленьких изображений в зависимости от ширины 
    useEffect(() => {
          const handleResize = () => {
            if (window.innerWidth <= 576) {
              setImagesToShow(3); // Мобильная ширина (xs)
            } else {
              setImagesToShow(4); // Десктоп по умолчанию
            }
          };
      
          handleResize(); // Вызываем при монтировании
          window.addEventListener('resize', handleResize); // Обновляем при ресайзе
          return () => window.removeEventListener('resize', handleResize); // Чистим
        }, []);


    // Функция для переключения изображений
    function handleImageClick(i) {
        setSelectedImage(process.env.REACT_APP_API_URL_PROD + "img/" + productItem.images[i]);
    }

    const handleNext = () => {
        setStartIndex((prevIndex) => Math.min(prevIndex + 1, productItem.images.length - 1));
    };
    
    const handlePrev = () => {
        setStartIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    };

    return (
        <div className="d-flex">
            <div className="d-flex flex-column me-4">
                    {productItem.images?.length > 0 ? (
                        <>
                            <button 
                                onClick={handlePrev} 
                                className="button-slide"
                                disabled={startIndex === 0}
                            >
                               <ChevronDoubleUp size={32}/>
                            </button>
                            {productItem.images.slice(startIndex, startIndex + imagesToShow).map((image, index) => ( // Добавить клик на картинку что бы открывалась в
                                <Image
                                    key={index}
                                    src={process.env.REACT_APP_API_URL_PROD + "img/" + image}
                                    onClick={() => handleImageClick(startIndex + index)}
                                    className="thumb-img rounded-4 mb-2"
                                    alt={productItem.name}
                                />
                            ))}
                            <button 
                                onClick={handleNext} 
                                className="button-slide"
                                disabled={startIndex + imagesToShow >= productItem.images.length}
                            >
                                <ChevronDoubleDown size={32}/>
                                </button>
                        </>
                    ) : (
                        <Image height={300} src={ImageNotFound} />
                    )}
            </div>
            <div className="d-block product-img">
                {productItem.images?.length > 0 &&
                    <Image src={selectedImage ? selectedImage : process.env.REACT_APP_API_URL_PROD + "img/" + productItem.images[0]} className="rounded-4 product-img big-image" alt={productItem.name} />
                }
                <Button
                    variant="outline-light"
                    className="arrow-left-link border-0"
                    onClick={() => {
                        if (selectedImageIndex > 0) {
                            setSelectedImageIndex(selectedImageIndex - 1)
                            handleImageClick(selectedImageIndex - 1);
                        }
                    }}>
                    <ArrowLeftCircle/>
                </Button>
                <Button
                    className="arrow-right-link border-0"
                    variant="outline-light"
                    onClick={() => {
                        if (selectedImageIndex < productItem.images?.length - 1) {
                            setSelectedImageIndex(selectedImageIndex + 1)
                            handleImageClick(selectedImageIndex + 1);
                        }
                    }}>
                    <ArrowRightCircle/>
                </Button>
            </div>
        </div>
    );
}

export default ImageGallery;